import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import BrandStripe from "@/components/BrandStripe";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <BrandStripe thickness="h-1" />
      <main className="flex-1">
        <Outlet />
      </main>
      <BrandStripe thickness="h-1" />
      <Footer />
    </div>
  );
}
